import type { FC } from "react";
import type { Card } from "../../../../../../types/cards.types";
import type { Player } from "../../../../../../types/teams.types";
import { toPlayerPhotoUrl } from "../../../../../../lib/media-proxy";
import * as CSS from "./player.styles";

type PlayerProps = {
	player: Player;
	sub?: { playerIn: string };
	playerCards: Card[];
	goals?: number;
	hasBeenSubbedOn?: boolean;
	showBottomBorder?: boolean;
};

const mapPositionToText = (position: string): string => {
	switch (position) {
		case "C":
			return "Coach";
		case "G":
			return "Goalkeeper";
		case "D":
			return "Defender";
		case "M":
			return "Midfielder";
		case "F":
			return "Forward";
		default:
			return "";
	}
};

const PlayerDisplay: FC<PlayerProps> = ({
	player,
	showBottomBorder = true,
}) => {
	return (
		<CSS.Player $showBottomBorder={showBottomBorder && player.number < 999}>
			<CSS.PlayerPicture src={toPlayerPhotoUrl(player.id)} alt="" />
			<span>
				<CSS.PlayerName>{player.name}</CSS.PlayerName>
				{player.number === 999 ? (
					<CSS.PlayerPosition>
						{mapPositionToText(player.position).toUpperCase()}
					</CSS.PlayerPosition>
				) : (
					<CSS.PlayerPosition>
						{player.number} · {mapPositionToText(player.position).toUpperCase()}
					</CSS.PlayerPosition>
				)}
			</span>
		</CSS.Player>
	);
};

export default PlayerDisplay;

// const PlayerRow = ({ player, sub, playerCards, goals }: PlayerRowProps) => (
//   <div>
//     <span>{player.number}</span>
//     <span
//       style={sub ? { textDecoration: "line-through", opacity: 0.5 } : undefined}
//     >
//       {" "}
//       {player.name}
//     </span>
//     {goals ? <span> {"⚽".repeat(goals)}</span> : null}
//     {playerCards.map((c) => (
//       <CardPip key={c.id} type={c.type} />
//     ))}
//     <span> · {POSITION_LABELS[player.position] ?? player.position}</span>
//     {sub && <span> ↑ {sub.playerIn}</span>}
//   </div>
// );
